import { Component, computed, inject, input, output, signal } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatPseudoCheckbox } from '@angular/material/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { RouterLink } from '@angular/router';
import { IdentityVerificationStatus, UserApplications, UserDto, UserRole } from '@workspace/data-types';
import { environment } from '@workspace/ng-config';
import {
  ApplicationStore,
  AuthStore,
  NavigationLayout,
  NavigationStore,
  Scheme,
} from '@workspace/ng-data-access';
import { ObfuscateEmailPipe } from '../../../../../pipes/obfuscate-email.pipe';
import { AvatarAuraComponent } from '../../../../media/avatar/avatar.component';
import { IdentityStatusComponent } from '../../../../user/identity-status/identity-status.component';
import { UserSubscriptionStatusAuraComponent } from '../../../../user/subscription-status/subscription-status.component';

@Component({
  selector: 'aura-sidebar-user',
  imports: [
    MatMenuTrigger,
    MatButton,
    MatIconModule,
    MatMenuModule,
    MatDividerModule,
    MatPseudoCheckbox,
    RouterLink,
    MatCheckbox,
    AvatarAuraComponent,
    ObfuscateEmailPipe,
    IdentityStatusComponent,
    UserSubscriptionStatusAuraComponent,
  ],
  templateUrl: './sidebar-user.component.html',
})
export class SidebarUserAuraComponent {
  private readonly authStore = inject(AuthStore);
  private readonly navigationStore = inject(NavigationStore);
  readonly user = input<UserDto>();
  readonly scheme = input.required<Scheme>();
  readonly schemeChanged = output<Scheme>();
  readonly isAdmin = computed(() => this.user()?.roles?.includes(UserRole.ADMIN) ?? false);
  readonly isAgent = computed(() => !!this.user()?.profiles?.agent);
  readonly isCurrentAppAgent = computed(
    () => this.appStore.currentApplicationName() === UserApplications.AGENT,
  );
  readonly agentProfileUrl = computed(() => {
    const baseUrl = (environment.apps?.agentUrl ?? '').replace(/\/$/, '');
    return `${baseUrl}/user/agent/settings`;
  });
  public isImpersonated = signal<boolean>(this.authStore.isImpersonated());
  public layout = signal<NavigationLayout | null>(this.navigationStore.layout());
  readonly Status = IdentityVerificationStatus;

  appStore = inject(ApplicationStore);

  schemes: { label: string; value: Scheme }[] = [
    { label: 'Clair', value: 'light' },
    { label: 'Sombre', value: 'dark' },
    { label: 'Système', value: 'system' },
  ];

  updateScheme(scheme: Scheme) {
    this.schemeChanged.emit(scheme);
  }

  closeImpersonate() {
    this.authStore.closeImpersonate().subscribe();
  }
}
